import { registerPlugin } from '@capacitor/core';
import { isNativeShell } from '../auth/authRedirect';

const LineMedicNotifications = registerPlugin('LineMedicNotifications');

export function nativeNotificationsAvailable() {
  return isNativeShell();
}

export async function getNativeNotificationStatus() {
  if (!nativeNotificationsAvailable()) {
    return { native: false, permission: 'unknown', registered: false };
  }
  return LineMedicNotifications.getStatus();
}

export async function requestNativeNotificationPermission() {
  if (!nativeNotificationsAvailable()) {
    return { native: false, permission: 'unknown', registered: false };
  }
  return LineMedicNotifications.requestPermission();
}

export async function registerNativeNotifications() {
  if (!nativeNotificationsAvailable()) {
    throw new Error('Native notifications are only available in the Line Medic iPhone app.');
  }
  return LineMedicNotifications.register();
}

export async function openNativeNotificationSettings() {
  if (!nativeNotificationsAvailable()) return false;
  await LineMedicNotifications.openSettings();
  return true;
}

export async function consumePendingNativeNotification() {
  if (!nativeNotificationsAvailable()) return { path: '' };
  return LineMedicNotifications.consumePendingNotification();
}

export function addNativeNotificationOpenedListener(callback) {
  if (!nativeNotificationsAvailable()) return Promise.resolve({ remove: async () => {} });
  return LineMedicNotifications.addListener('notificationOpened', event => {
    const path = String(event?.path || '').trim();
    if (path && typeof callback === 'function') callback(path);
  });
}
